import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const FileSearchAlt = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 8H19.4L14 2.6V7C14 7.6 14.4 8 15 8ZM23.7 20.3L22.6 19.2C22.9 18.7 23 18.1 23 17.5C23 15.6 21.4 14 19.5 14C17.6 14 16 15.6 16 17.5C16 19.4 17.6 21 19.5 21C20.1 21 20.6 20.8 21.2 20.6L22.3 21.7C22.7 22.1 23.3 22.1 23.7 21.7C24.1 21.3 24.1 20.7 23.7 20.3ZM19.5 19C18.7 19 18 18.3 18 17.5C18 16.7 18.7 16 19.5 16C20.3 16 21 16.7 21 17.5C21 18.3 20.3 19 19.5 19ZM14.5 17.5C14.5 14.8 16.7 12.5 19.4 12.5C19.6 12.5 19.8 12.5 20 12.5V10H15C13.3 10 12 8.7 12 7V2H7C5.3 2 4 3.3 4 5V19C4 20.7 5.3 22 7 22H17C17.1 22 17.2 22 17.3 22C15.6 21.2 14.5 19.4 14.5 17.5ZM9 8H10C10.6 8 11 8.4 11 9C11 9.6 10.6 10 10 10H9C8.4 10 8 9.6 8 9C8 8.4 8.4 8 9 8ZM11 18H9C8.4 18 8 17.6 8 17C8 16.4 8.4 16 9 16H11C11.6 16 12 16.4 12 17C12 17.6 11.6 18 11 18ZM13 14H9C8.4 14 8 13.6 8 13C8 12.4 8.4 12 9 12H13C13.6 12 14 12.4 14 13C14 13.6 13.6 14 13 14Z"
      fill="currentColor"
    />
  </svg>
)

export default FileSearchAlt
